import './registerServiceWorker'
import initApp from './bootstrap'
const app = initApp()
app.$mount('#app')
